// extracted by mini-css-extract-plugin
export default {"downloadItem":"downloadItem__IhXJH","files":"files__efi2g"};